// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__NQOJA","inputWrapper":"Search_inputWrapper__Y94q4","search":"Search_search__cP-hz","searchButton":"Search_searchButton__juggw"};